/**
 * @generated SignedSource<<3cb4982595a5f936e92b9b03c49230e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_item$data = {
  readonly isJewelry: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_item" | "PdpSharedIconBubbleEmail_item" | "PdpSharedIconBubbleFacebook_item" | "PdpSharedIconBubblePinterest_item">;
  readonly " $fragmentType": "PdpRespIconBubbles_item";
};
export type PdpRespIconBubbles_item$key = {
  readonly " $data"?: PdpRespIconBubbles_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJewelry",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubblePinterest_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleFacebook_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbleShare_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "e3ee7e47d8cab7e963eda39bd5ee97de";

export default node;
